import { atomWithGlobalStore } from '@highlight/ipc/jotai'
import { useAtomValue, useSetAtom } from 'jotai'

export const transcriptMergingAtom = atomWithGlobalStore<boolean>('settings', 'audio-notes.transcript-merging', true)

export const useIsAudioTranscriptMerging = () => {
  return useAtomValue(transcriptMergingAtom)
}

export const useSetAudioTranscriptMerging = () => {
  return useSetAtom(transcriptMergingAtom)
}
